import { Component, Input, OnInit } from '@angular/core';
import { PlantillaComponent } from '../plantilla.component';
import { Funcionalidad } from '../../../_models/funcionalidad';

@Component( {
  selector: 'app-barra-lateral-menu',
  templateUrl: 'barra-lateral-menu.component.html'
} )

export class BarraLateralMenuComponent implements OnInit {

  @Input() menu: Funcionalidad = new Funcionalidad();

  public model: any[];

  constructor( public app: PlantillaComponent ) {
  }

  ngOnInit() {
    const modelo = [];
    if ( this.menu.hijos.length > 0 ) {
      this.menu.hijos.map( ( s: Funcionalidad ) => {
        modelo.push( { label: s.menu, icon: s.clase, routerLink: [ s.ruta ], nuevo: s.nuevo } );
      } );
    } else {
      modelo.push( { label: this.menu.menu, icon: this.menu.clase, routerLink: [ this.menu.ruta ], nuevo: this.menu.nuevo } );
    }
    this.model = modelo;
  }

  changeTheme( theme ) {
    const themeLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById( 'theme-css' );
    const themeLinkGreen: HTMLLinkElement = <HTMLLinkElement> document.getElementById( 'theme-css-green' );
    const layoutLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById( 'layout-css' );

    themeLink.href = 'assets/theme/theme-' + theme + '.css';
    themeLinkGreen.href = 'assets/theme/bootstrap4-light-blue/theme.css';
    layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
  }

}
